import React from 'react'
import { useTheme } from 'styled-components'
import { defaultFaIconCx } from './style'

type Props = React.HTMLAttributes<HTMLElement>

const FaCalendar = ({ style, ...props }: Props) => {
  const theme = useTheme() as any
  const mergedClassName = ['fa-regular fa-calendar', defaultFaIconCx].join(' ')

  return (
    <i
      className={mergedClassName}
      style={!style ? { color: theme.primary } : undefined}
      {...props}></i>
  )
}

export default React.memo(FaCalendar)
